import React from "react"

export const SourcesMicroOverview = () => {

return(
<div>
Journal of Human Hypertension (2022) 36:952 – 959: Recent advances in modulation of cardiovascular diseases by
the gut microbiota<br />
https://www.niehs.nih.gov/health/topics/science/microbiome#:~:text=Introduction,to%20human%20health%20and%20wellness.<br />
</div>
)
}